import React from 'react'

const EmailIcon = props => (
  <svg
    width={18}
    height={14}
    {...props}
  >
    <title>{'emailtranscript'}</title>
    <path
      d="M15.667.333H2.333C1.417.333.675 1.083.675 2L.667 12c0 .917.75 1.667 1.666 1.667h13.334c.916 0 1.666-.75 1.666-1.667V2c0-.917-.75-1.667-1.666-1.667zm0 11.667H2.333V3.667L9 7.833l6.667-4.166V12zM9 6.167L2.333 2h13.334L9 6.167z"
      fillOpacity={0.6}
      fill="#424D57"
      fillRule="nonzero"
    />
  </svg>
)

export default EmailIcon



// WEBPACK FOOTER //
// ./src/components/EmailIcon.js